import React, { useState } from 'react';
import { Button, Form, Input, Upload } from 'antd';
import { apiClient, apiErrorMessage } from '../../utils';
import { InboxOutlined } from '@ant-design/icons';

export function NewHelpDocumentPage(props: { onSaved: () => void }) {
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<any>();
  
  const { Dragger } = Upload;

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    setUploadedFile(e.file.originFileObj);
    return e && e.fileList;
  };

  const dummyUploadRequest = ({ onSuccess }: any) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onFinish = (values: any) => {
    setLoading(true);

    var formData = new FormData();
    formData.append('file', uploadedFile);

    for (let key of Object.keys(values)) {
      if (key !== 'dragger' && values[key]) {
        formData.append(key, values[key]);
      }
    }

    apiClient
      .post('help/documents', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} name="basic" onFinish={onFinish}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/,
            message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir',
          },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Revizyon"
        name="revision"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="Açıklama" name="description" rules={[{ max: 400, message: 'En fazla 400 karakter' }]}>
        <Input.TextArea />
      </Form.Item>
      <Form.Item label="Dosya">
        <Form.Item
          name="dragger"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          noStyle
          rules={[{ required: true, message: 'Zorunlu alan' }]}
        >
          <Dragger name="files" maxCount={1} customRequest={dummyUploadRequest}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Bir dosya sürükleyin veya tıklayın</p>
            <p className="ant-upload-hint">Yüklenen dosyaların şirket içinde genel erişime açık olduğunu lütfen unutmayın.</p>
          </Dragger>
        </Form.Item>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
